export enum PositionEnum {
  top = 'top',
  bottom = 'bottom',
  right = 'right',
  left = 'left',
}

export enum SpacingEnum {
  xxxs = 'xxxs',
  xxs = 'xxs',
  xs = 'xs',
  s = 's',
  m = 'm',
  l = 'l',
  xl = 'xl',
  xxl = 'xxl',
  xxxl = 'xxxl',
}

export enum ZIndexEnum {
  blackHole = 'blackHole',
  low = 'low',
  sticky = 'sticky',
  overlay = 'overlay',
  modal = 'modal',
  topOfTheWorld = 'topOfTheWorld',
}

export enum BorderSizeEnum {
  s = 's',
  m = 'm',
  l = 'l',
}

export enum BreakpointsEnum {
  s = 's',
  m = 'm',
  l = 'l',
}

export enum ShadowsEnum {
  normal = 'normal',
  light = 'light',
  lighter = 'lighter',
  intense = 'intense',
}
export enum BorderTypeEnum {
  solid = 'solid',
  dashed = 'dashed',
}

export enum BorderRadiusEnum {
  normal = 'normal',
  rounded = 'rounded',
  circle = 'circle',
}

export enum ColorsEnum {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  grey = 'grey',
  success = 'success',
  warning = 'warning',
  error = 'error',
  info = 'info',
  neutral = 'neutral',
}

export enum ColorsToneEnum {
  darker = 'darker',
  dark = 'dark',
  neutral = 'neutral',
  light = 'light',
  lighter = 'lighter',
  lightest = 'lightest',
}

export enum FontWeightEnum {
  bold = 'bold',
  medium = 'medium',
  normal = 'normal',
}

export enum TypographyEnum {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
  m = 'm',
  s = 's',
  xs = 'xs',
  xxs = 'xxs',
}
